import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

interface Organization {
  id: string
  name: string
  connection: boolean
  connection_url: string
}

export interface ListOrganizations {
  auth_url: string
  authorize: boolean
  organizations: Organization[]
}

export async function listOrganizations(options?: AxiosRequestConfig) {
  const { data } = await usersApi.get<ListOrganizations>(
    apiRoutes.listOrganizations('john-deere'),
    options,
  )

  return data
}
